import React from 'react';
import useStatus from './hooks/useStatus';
import Painting from './Painting';
import Reinstatement from './Reinstatement';
import Removal from './Removal';

const Insulation = (props: any) => {
  const [statusRequest] = useStatus();
  return (
    <>
      {statusRequest?.type === 'INSTATEMENT' && <Reinstatement {...props} />}
      {statusRequest?.type === 'PAINTING' && <Painting {...props} />}
      {statusRequest?.type === 'REMOVAL' && <Removal {...props} />}
    </>
  );
};

export default Insulation;
